import React from 'react';
import sIcon1 from '../../images/icons/icon_user_check.svg'
import sIcon2 from '../../images/icons/icon_headphone.svg'
import sIcon3 from '../../images/icons/icon_dollar.svg'

const Policy = [
    {
        title: 'Embedded from day one',
        subTitle: 'Strategic technology planning from pre-construction through operations handoff — not bolted on at the end.',
        icon: sIcon1,
    },
    {
        title: 'Revenue, not just expense',
        subTitle: 'ISP door fees, profit sharing, and grant funding (CASF/CPUC) — turning building tech into income before move-in.',
        icon: sIcon2,
    },
    {
        title: 'Transparent per-unit pricing',
        subTitle: '$310/unit covers full design, ISP negotiation, and coordination through closeout. No surprises, no upcharge.',
        icon: sIcon3,
    },


]


const PolicySection = (props) => {

    return (
        <section className="policy_section">
            <div className="container">
                <div className="row">
                    {Policy.map((policy, pitem) => (
                        <div className="col-lg-4" key={pitem}>
                            <div className="iconbox_block layout_icon_left">
                                <div className="iconbox_icon bg-secondary-subtle">
                                    <img src={policy.icon} alt="Dollar SVG Icon" />
                                </div>
                                <div className="iconbox_content">
                                    <h3 className="iconbox_title">{policy.title}</h3>
                                    <p className="mb-0">
                                        {policy.subTitle}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default PolicySection;